import { useUser } from '@vivaldis/session'

export const useCompanyHasSelectionAccess = () => {
  const user = useUser()

  // More about navigation menu -> https://sealjobs.atlassian.net/wiki/spaces/SJ/pages/2157936641/Navigation+menu
  // Company has "Selection" level when it has at least one none-payroll offer
  return !!user?.company?.hasNonPayrollOffers
}
